module.exports = __webpack_public_path__ + "img/lageplan_800.1ba98209.jpg";